import { render, staticRenderFns } from "./StartStudy.vue?vue&type=template&id=1fc0bd80&"
import script from "./StartStudy.vue?vue&type=script&lang=js&"
export * from "./StartStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports